import React, { useCallback, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginWithGoogle, signupUser } from '../api/userAPI';
import { verifyOTP } from '../api/authAPI';
import "../css/SignupPage.css";
import logoImage from '../assets/image/logo1.webp';
import { useUser } from '../contexts/UserContext';
import GoogleAuthButton from './GoogleAuthButton';

function SignupPage() {
  const { setUser } = useUser();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    otp: '',
  });
  const [error, setError] = useState('');
  const [awaitingOTP, setAwaitingOTP] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSignupSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await signupUser({
        username: formData.username,
        email: formData.email,
        password: formData.password
      });
      setAwaitingOTP(true);
    } catch (signupError) {
      console.error('Signup Failed:', signupError.message);
      setError(signupError.message || 'Signup Failed. Please try again.');
    }
  };

  const handleOTPSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await verifyOTP({
        email: formData.email,
        otp: formData.otp
      });
      navigate('/login');
    } catch (verifyError) {
      console.error('OTP Verification Failed:', verifyError);
      setError(verifyError.message || 'OTP verification failed. Please try again.');

      if (verifyError.message.includes('Maximum OTP verification')) {
        setError(`${verifyError.message} Reloading .....`);
        setTimeout(() => window.location.href = '/signup', 1500);
      }
    }
  };

  const handleGoogleSignup = useCallback(async (credential) => {
    const responseData = await loginWithGoogle(credential);
    setUser(responseData.user);
    navigate('/');
  }, [navigate, setUser]);

  return (
    <main id="sp-pageContent" className="sp-tt-offset-none">
      <div className="sp-container">
        <div className="sp-tt-loginpages-wrapper">
          <div className="sp-tt-loginpages">
            <Link to="/" className="sp-tt-block-title">
              <img src={logoImage} alt="Logo" className="login-logo" />
              <div className="sp-tt-title">
                Welcome to InterviewBlogs
              </div>
              <div className="sp-tt-description">
                Join the forum to unlock the true power of community.
              </div>
            </Link>
            {!awaitingOTP ? (
              <form className="sp-form-default" onSubmit={handleSignupSubmit}>
                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                <div className="sp-form-group">
                  <label htmlFor="sp-loginUserName">Username</label>
                  <input type="text" name="username" className="sp-form-control" id="sp-loginUserName" placeholder="JohnDoe" value={formData.username} onChange={handleChange} />
                </div>
                <div className="sp-form-group">
                  <label htmlFor="sp-loginUserEmail">Email</label>
                  <input type="email" name="email" className="sp-form-control" id="sp-loginUserEmail" placeholder="johndoe@gmail.com" value={formData.email} onChange={handleChange} />
                </div>
                <div className="sp-form-group">
                  <label htmlFor="sp-loginUserPassword">Password</label>
                  <input type="password" name="password" className="sp-form-control" id="sp-loginUserPassword" placeholder="************" value={formData.password} onChange={handleChange} />
                </div>
                <div className="sp-form-group">
                  <button type="submit" className="sp-btn sp-btn-secondary sp-btn-block">Create my account</button>
                </div>
                <div className="auth-divider"><span>or continue with</span></div>
                <GoogleAuthButton
                  text="signup_with"
                  onCredential={handleGoogleSignup}
                  onError={(googleError) => setError(googleError.message)}
                />
                <p className="heelop">Already have an account? <Link to="/login" className="sp-tt-underline">Login here</Link></p>
              </form>
            ) : (
              <form className="sp-form-default" onSubmit={handleOTPSubmit}>
                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                <div className="sp-form-group">
                  <label htmlFor="sp-loginUserOTP">OTP</label>
                  <input type="text" name="otp" className="sp-form-control" id="sp-loginUserOTP" placeholder="Enter your OTP" value={formData.otp} onChange={handleChange} />
                </div>
                <button type="submit" className="sp-btn sp-btn-secondary sp-btn-block">Verify OTP</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default SignupPage;
